import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  DialogTitle,
  TableRow,
  TableCell,
  TableHead,
  Table,
  TableContainer,
  Grid,
  TableBody,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import { connect, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import { START_GLOBAL_SETTING_ACCESS } from "Actions/RepeatOrderAction";
import TableEmptyState from "Components/Common/Table/TableEmptyState";
import clsx from "clsx";
import { START_CREATE_SURGERY_MULTI } from "Actions/SurgeryAction";
const useStyle = makeStyles((theme) => ({
  rsAccessMain: {
    display: "flex",
    justifyContent: "flex-start",
    paddingBottom: "10px",
    "&>h5": {
      paddingRight: "5px",
    },
  },
  rsAlignMain: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  tableBody: {
    "& .MuiTableContainer-root": {
      maxHeight: "calc(80vh - 200px) !important",
      padding: "0px !important",
    },
    "&>tr": {
      "&>td": {
        padding: "14px 20px !important",
        borderRight: "none !important",
        // whiteSpace: "nowrap",
      },
    },
  },
  tableHead: {
    "&>tr": {
      "&>th": {
        paddingLeft: "20px",
        //  paddingRight: "30px !important",
        whiteSpace: "nowrap",
      },
    },
  },
  tableContainer: {
    marginBottom: "20px !important",
    height: "auto !important",
    padding: "0",
    "&>table": {
      border: "1px solid #e0e0e0",
    },
  },
  rsDialogContent: {
    paddingTop: "0px !important",
  },
  rsDialogMainRoot: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      position: "absolute",
      top: "0 !important",
      paddingTop: "20px",
      paddingBottom: "20px",
      [theme.breakpoints.down("1102")]: {
        maxWidth: "75% !important",
      },
    },
  },
  rsSelectAll: {
    width: "10% !important",
    borderRight: "none !important",
  },
}));

const ImportSurgeryDialog = (props) => {
  const {
    open,
    setOpen,
    surgeryData,
    handleClose,
    createSurgeryMultipleAction,
    createSurgeryMultiData,
    surgerySubmit,
    setSurgerySubmit,
    fileType,
  } = props;
  const classes = useStyle();
  const loginUserDetail = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [surgeryNameList, setSurgeryListName] = useState([]);
  const handleCheckBox = (name) => {
    if (data.includes(name)) {
      let tempCollectArr = data.filter((data) => data !== name);
      setData(tempCollectArr);
      if (isCheckAll) {
        setIsCheckAll(false);
      }
    } else {
      setData([...data, name]);
    }
  };
  useEffect(() => {
    if (data?.length === surgeryNameList?.length && open == true) {
      setIsCheckAll(true);
    }
  }, [data?.length, surgeryNameList?.length]);
  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    if (isCheckAll === true) {
      setData([]);
    } else {
      setData(surgeryNameList.map((li) => li[1].name));
    }
  };
  const handleSubmit = () => {
    let tempArray = [];
    surgeryNameList.filter((li) => {
      data?.map((item) => {
        if (li[1].name === item) {
          tempArray.push(li[1]);
        }
      });
    });

    let payLoad = {
      surgeries: tempArray,
    };
    if (data?.length > 0) {
      createSurgeryMultipleAction(payLoad);
      setSurgerySubmit(true);
    } else {
      handleClose();
      setData([]);
      setSurgerySubmit(false);
    }
  };
  useEffect(() => {
    if (
      createSurgeryMultiData?.data?.success === true &&
      surgerySubmit === true
    ) {
      handleClose();
      setData([]);
    }
  }, [createSurgeryMultiData?.data]);
  useEffect(() => {
    if (surgeryData !== undefined && surgeryData !== "") {
      const arrayFromObject = Object.entries(surgeryData);
      arrayFromObject.forEach(([key, value]) => {});
      setSurgeryListName(arrayFromObject);
    }
  }, [surgeryData]);
  useEffect(() => {
    if (open) {
      setIsCheckAll(true);
      setData(surgeryNameList.map((li) => li[1].name));
    }
  }, [surgeryNameList]);
  return (
    <>
      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
            setData([]);
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={clsx(classes.rsDialogMainRoot)}
      >
        <DialogTitle>
          <Typography>Create Surgery</Typography>{" "}
        </DialogTitle>
        <DialogContent className={classes.rsDialogContent}>
          <Box className={classes.rsAlignMain}>
            <Grid className="common-table">
              <TableContainer className={classes.tableContainer}>
                <Table stickyHeader>
                  <TableHead className={classes.tableHead}>
                    <TableRow>
                      <TableCell className={classes.rsSelectAll}>
                        {" "}
                        <Checkbox
                          checked={isCheckAll}
                          onChange={() => {
                            handleSelectAll();
                          }}
                        />
                      </TableCell>
                      <TableCell>SURGERY NAME</TableCell>
                      <TableCell>SURGERY ADDRESS</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className={classes.tableBody}>
                    {surgeryNameList?.map((item, key) => {
                      return (
                        <>
                          <TableRow>
                            <TableCell>
                              <Checkbox
                                checked={data?.includes(item[1].name)}
                                onChange={(e) => {
                                  handleCheckBox(item[1].name);
                                }}
                              />
                            </TableCell>
                            <TableCell>{item[1].name}</TableCell>
                            <TableCell>{item[1].address}</TableCell>
                          </TableRow>
                        </>
                      );
                    })}
                  </TableBody>
                  {surgeryNameList?.length <= 0 && (
                    <>
                      <TableEmptyState />
                    </>
                  )}
                </Table>
              </TableContainer>
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            disabled={createSurgeryMultiData?.loading}
            onClick={() => handleSubmit()}
          >
            {createSurgeryMultiData?.loading && (
              <CircularProgress
                color="white"
                size="15px"
                style={{ marginRight: "10px" }}
              />
            )}
            Submit
          </Button>
          <Button
            variant="outlined"
            // disabled={createSurgeryMultiData?.loading}
            onClick={() => {
              handleClose();
              setData([]);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => ({
  globalSettingAccess: state.order.globalSettingAccess,
  createSurgeryMultiData: state.surgery.createSurgeryMultiData,
});
const mapDispatchToProps = (dispatch) => ({
  getGlobalSettingAccessAction: () =>
    dispatch({ type: START_GLOBAL_SETTING_ACCESS }),
  createSurgeryMultipleAction: (payload) =>
    dispatch({ type: START_CREATE_SURGERY_MULTI, payload }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportSurgeryDialog);
